import { PropsWithChildren } from "react";
import { makeStyles } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import ExtensionIcon from "@material-ui/icons/Extension";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import ListAltIcon from "@material-ui/icons/ListAlt";
import LogoFull from "./LogoFull";
import LogoIcon from "./LogoIcon";
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from "@backstage/plugin-user-settings";
import { SidebarSearchModal } from "@backstage/plugin-search";
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarSpace,
  SidebarSubmenuItem,
  useSidebarOpenState,
  Link,
} from "@backstage/core-components";
import DashboardIcon from "@material-ui/icons/Dashboard";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import GroupIcon from '@material-ui/icons/People';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import MenuBookIcon from "@material-ui/icons/MenuBook";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import BuildIcon from "@material-ui/icons/Build";
import TocIcon from "@material-ui/icons/Toc";
import FlightTakeoffIcon from "@material-ui/icons/FlightTakeoff";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center",
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarItem
        icon={HelpOutlineIcon}
        to="/docs/default/Component/getting-started-with-backstage"
        text="Introduction"
      />
      <SidebarItem icon={HomeIcon} to="/" text="Home" />
      <MyGroupsSidebarItem
          singularTitle="My Group"
          pluralTitle="My Groups"
          icon={GroupIcon}
      />
      <SidebarDivider />
      <NotificationsSidebarItem />
      <SidebarDivider />
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        <SidebarSubmenuItem icon={MenuBookIcon} to="catalog" title="Catalog" />
        <SidebarSubmenuItem icon={ExtensionIcon} to="api-docs" title="APIs" />
        <SidebarSubmenuItem icon={LibraryBooks} to="docs" title="Docs" />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        <SidebarItem icon={TocIcon} to="read-aws-data" text="Project List" />
        <SidebarItem icon={ListAltIcon} to="container-scans" text="Container Scans" />
        <SidebarItem icon={ExtensionIcon} to="feature-deploy" text="Learn Feature Deployments" />
        <SidebarItem icon={FlightTakeoffIcon} to="regional-deploy" text="Regional Deployments">
        </SidebarItem>
        <SidebarItem icon={CheckCircleOutline} to="compliance-ui" text="Compliance" />
        <SidebarItem icon={DashboardIcon} to="devops-metrics" text="DevOps Metrics" />
      </SidebarGroup>
      <SidebarSpace />
      <SidebarDivider />
      <SidebarGroup label="Settings" icon={<UserSettingsSignInAvatar />} to="/settings">
        <SidebarSettings />
        <SidebarItem icon={BuildIcon} to="devtools" text="DevTools" />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);
